module.exports = __webpack_public_path__ + "static/media/prosperidad.7286448e.png";